/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateOrUpdateInstructionDto } from './CreateOrUpdateInstructionDto';
import {
    instanceOfCreateOrUpdateInstructionDto,
    CreateOrUpdateInstructionDtoFromJSON,
    CreateOrUpdateInstructionDtoFromJSONTyped,
    CreateOrUpdateInstructionDtoToJSON,
} from './CreateOrUpdateInstructionDto';

/**
 * @type CreateOrUpdateTaskItemAreaDtoInstruction
 * 
 * @export
 */
export type CreateOrUpdateTaskItemAreaDtoInstruction = CreateOrUpdateInstructionDto;


export function CreateOrUpdateTaskItemAreaDtoInstructionFromJSON(json: any): CreateOrUpdateTaskItemAreaDtoInstruction {
    return CreateOrUpdateTaskItemAreaDtoInstructionFromJSONTyped(json, false);
}

export function CreateOrUpdateTaskItemAreaDtoInstructionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateTaskItemAreaDtoInstruction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...CreateOrUpdateInstructionDtoFromJSONTyped(json, true) };
    return  CreateOrUpdateInstructionDtoFromJSONTyped(json, true);
}

export function CreateOrUpdateTaskItemAreaDtoInstructionToJSON(value?: CreateOrUpdateTaskItemAreaDtoInstruction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCreateOrUpdateInstructionDto(value)) {
        return CreateOrUpdateInstructionDtoToJSON(value as CreateOrUpdateInstructionDto);
    }

    return {};
}

/**
 * Check if a given object implements the CreateOrUpdateTaskItemAreaDtoInstruction interface.
 */
export function instanceOfCreateOrUpdateTaskItemAreaDtoInstruction(value: any): value is CreateOrUpdateTaskItemAreaDtoInstruction {
    if (instanceOfCreateOrUpdateInstructionDto(value)) return true;
    return false;
}

